module.exports = __webpack_public_path__ + "static/media/ice-hockey.30584a7d.png";